import { render, staticRenderFns } from "./CandidateLogs.vue?vue&type=template&id=7242ace2"
import script from "./CandidateLogs.vue?vue&type=script&lang=js"
export * from "./CandidateLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports